import { DatePicker, Divider, Form, message, Modal } from "antd";
import PercentageInput from "components/inputs/PercentageInput";
import { LABEL_ALIGN, RULE_REQUIRED } from "constants";
import useMutation from "hooks/useMutation";
import { showErrorModal } from "utils";
import { createAumentos } from "../../api";
import { PRECIOS_TIPOS } from "constants";

const Renovar = ({ title, storedValues, estoyEnListaPrecios, estoyEnAdicionales, estoyEnSeguros, onAfterRenovar, closeModal }) => {
  const [form] = Form.useForm();
  const precio = Form.useWatch("porcentaje_precio", form);
  const excedente = Form.useWatch("porcentaje_excedente", form);
  const retiro = Form.useWatch("porcentaje_retiro", form);
  const retiroExcedente = Form.useWatch("porcentaje_retiro_excedente", form);
  const entrega = Form.useWatch("porcentaje_entrega", form);
  const entregaExcedente = Form.useWatch("porcentaje_entrega_excedente", form);

  const create = useMutation({
    mutationFn: createAumentos,
    onSuccess: (res) => {
      message.success(res.message);
      onAfterRenovar?.();
      closeModal();
    },
    onError: (err) => showErrorModal({ err }),
  });

  const onFinish = (values) => {
    const { precio, adicional, seguro } = storedValues;

    let aumentos = {
      ...values,
      precios_tipo: estoyEnListaPrecios ? 1 : estoyEnAdicionales ? 2 : 3,
      precios_tipos_id: PRECIOS_TIPOS.LISTA_GENERAL,
    }

    if (estoyEnListaPrecios) {
      aumentos = precio?.map(p => ({
        ...aumentos,
        precios_id: p.id,
        distancias_ids: p.tramos,
        articulos_ids: p.articulos,
        unidades: p.unidades,
      }));
    }

    if (estoyEnAdicionales) {
      aumentos = adicional?.map(a => ({
        ...aumentos,
        precios_id: a.id,
        grupos_ids: a.grupos,
        articulos_ids: a.articulos,
        unidades: a.unidades,
      }));
    }

    if (estoyEnSeguros) {
      aumentos = seguro?.map(s => ({
        ...aumentos,
        precios_id: s.id,
        precios_seguros: s.seguros?.map(item => ({
          precios_id: s.id,
          articulos_id: item.articulos_id,
          seguro: item.seguro,
          seguro_minimo: item.seguro_minimo,
          seguro_maximo: item.seguro_maximo,
          seguro_sin_documentacion: item.seguro_sin_documentacion,
        })),
      }))
    }

    Modal.confirm({
      title: `¿Está seguro de que desea renovar ${title}?`,
      okText: 'SÍ',
      okType: 'danger',
      cancelText: 'NO',
      onOk() {
        create.mutate({ aumentos });
      },
    })
  }

  return (
    <Modal
      width={350}
      title={`Renovar ${title}`}
      okText="Renovar"
      onOk={() => form.submit()}
      open={true}
      onCancel={closeModal}
      destroyOnHidden
      confirmLoading={create.loading}
      okButtonProps={{
        disabled: estoyEnListaPrecios
          ? (precio == null && excedente == null)
          : estoyEnAdicionales
            ? (retiro == null && retiroExcedente == null && entrega == null && entregaExcedente == null)
            : undefined
      }}
    >
      <Form
        form={form}
        onFinish={onFinish}
        labelAlign={LABEL_ALIGN}
        labelCol={{ flex: '130px' }}
        autoComplete="off"
      >
        <Form.Item
          label="Fecha de inicio"
          name="fecha"
          rules={[RULE_REQUIRED]}
        >
          <DatePicker />
        </Form.Item>
        {estoyEnListaPrecios &&
          <>
            <Form.Item
              label="Precio"
              name="porcentaje_precio"
            >
              <PercentageInput />
            </Form.Item>
            <Form.Item
              label="Excedente"
              name="porcentaje_excedente"
            >
              <PercentageInput />
            </Form.Item>
          </>
        }
        {estoyEnAdicionales && (
          <>
            <Divider orientation="left" orientationMargin="0">
              Aumento Retiro
            </Divider>

            <Form.Item
              label="Precio"
              name="porcentaje_retiro"
            >
              <PercentageInput />
            </Form.Item>
            <Form.Item
              label="Excedente"
              name="porcentaje_retiro_excedente"
            >
              <PercentageInput />
            </Form.Item>

            <Divider orientation="left" orientationMargin="0">
              Aumento Entrega
            </Divider>
            <Form.Item
              label="Precio"
              name="porcentaje_entrega"
            >
              <PercentageInput />
            </Form.Item>
            <Form.Item
              label="Excedente"
              name="porcentaje_entrega_excedente"
            >
              <PercentageInput />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
}

export default Renovar;